/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const listCases = /* GraphQL */ `query ListCases($locationNum: String!, $contactGuid: String, $page: Int) {
  listCases(locationNum: $locationNum, contactGuid: $contactGuid, page: $page) {
    id
    number
    confidential
    status
    description
    longDescription
    assignedTo {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    contact {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    commentsAll
    openedOn
    updatedOn
    closedOn
    locationNum
    fieldMutated
    requestedItem {
      id
      number
      requestOptions {
        label
        supportingLabels
        value
        filterSets
        matches
        hiddenMatches
        __typename
      }
      __typename
    }
    submissionDetails {
      label
      supportingLabels
      value
      filterSets
      matches
      hiddenMatches
      __typename
    }
    activityStream {
      id
      caseId
      text
      createdBy {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      createdOn
      locationNum

      ... on ActivityStreamComment {
        translatedText
      }
      ... on ActivityStreamAttachment {
        downloadURL
        fileName
        mimeType
      }
    }
    canRequestUpdate
    willCloseOn
    isUnread
    promptTypes
    __typename
  }
}
` as GeneratedQuery<APITypes.ListCasesQueryVariables, APITypes.ListCasesQuery>;
export const openCases = /* GraphQL */ `query OpenCases($locationNum: String!, $contactGuid: String, $page: Int) {
  openCases(locationNum: $locationNum, contactGuid: $contactGuid, page: $page) {
    pageInfo {
      totalItems
      totalPages
      hasNextPage
      __typename
    }
    cases {
      id
      number
      confidential
      status
      description
      longDescription
      assignedTo {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      contact {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      commentsAll
      openedOn
      updatedOn
      closedOn
      locationNum
      fieldMutated
      requestedItem {
        id
        number
        requestOptions {
          label
          supportingLabels
          value
          filterSets
          matches
          hiddenMatches
          __typename
        }
        __typename
      }
      submissionDetails {
        label
        supportingLabels
        value
        filterSets
        matches
        hiddenMatches
        __typename
      }
      activityStream {
        id
        caseId
        text
        createdBy {
          id
          firstName
          lastName
          fullName
          guid
          userName
          audience
          personId
          photoURL
          photo
          mobilePhone
          email
          title
          __typename
        }
        createdOn
        locationNum

        ... on ActivityStreamComment {
          translatedText
        }
        ... on ActivityStreamAttachment {
          downloadURL
          fileName
          mimeType
        }
      }
      canRequestUpdate
      willCloseOn
      isUnread
      promptTypes
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.OpenCasesQueryVariables, APITypes.OpenCasesQuery>;
export const listClosedCases = /* GraphQL */ `query ListClosedCases($locationNum: String!, $page: Int) {
  listClosedCases(locationNum: $locationNum, page: $page) {
    id
    number
    confidential
    status
    description
    longDescription
    assignedTo {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    contact {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    commentsAll
    openedOn
    updatedOn
    closedOn
    locationNum
    fieldMutated
    requestedItem {
      id
      number
      requestOptions {
        label
        supportingLabels
        value
        filterSets
        matches
        hiddenMatches
        __typename
      }
      __typename
    }
    submissionDetails {
      label
      supportingLabels
      value
      filterSets
      matches
      hiddenMatches
      __typename
    }
    activityStream {
      id
      caseId
      text
      createdBy {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      createdOn
      locationNum

      ... on ActivityStreamComment {
        translatedText
      }
      ... on ActivityStreamAttachment {
        downloadURL
        fileName
        mimeType
      }
    }
    canRequestUpdate
    willCloseOn
    isUnread
    promptTypes
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClosedCasesQueryVariables,
  APITypes.ListClosedCasesQuery
>;
export const closedCases = /* GraphQL */ `query ClosedCases($locationNum: String!, $page: Int) {
  closedCases(locationNum: $locationNum, page: $page) {
    pageInfo {
      totalItems
      totalPages
      hasNextPage
      __typename
    }
    cases {
      id
      number
      confidential
      status
      description
      longDescription
      assignedTo {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      contact {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      commentsAll
      openedOn
      updatedOn
      closedOn
      locationNum
      fieldMutated
      requestedItem {
        id
        number
        requestOptions {
          label
          supportingLabels
          value
          filterSets
          matches
          hiddenMatches
          __typename
        }
        __typename
      }
      submissionDetails {
        label
        supportingLabels
        value
        filterSets
        matches
        hiddenMatches
        __typename
      }
      activityStream {
        id
        caseId
        text
        createdBy {
          id
          firstName
          lastName
          fullName
          guid
          userName
          audience
          personId
          photoURL
          photo
          mobilePhone
          email
          title
          __typename
        }
        createdOn
        locationNum

        ... on ActivityStreamComment {
          translatedText
        }
        ... on ActivityStreamAttachment {
          downloadURL
          fileName
          mimeType
        }
      }
      canRequestUpdate
      willCloseOn
      isUnread
      promptTypes
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClosedCasesQueryVariables,
  APITypes.ClosedCasesQuery
>;
export const cases = /* GraphQL */ `query Cases($locationNum: String!, $page: Int) {
  cases(locationNum: $locationNum, page: $page) {
    pageInfo {
      totalItems
      totalPages
      hasNextPage
      __typename
    }
    cases {
      id
      number
      confidential
      status
      description
      longDescription
      assignedTo {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      contact {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      commentsAll
      openedOn
      updatedOn
      closedOn
      locationNum
      fieldMutated
      requestedItem {
        id
        number
        requestOptions {
          label
          supportingLabels
          value
          filterSets
          matches
          hiddenMatches
          __typename
        }
        __typename
      }
      submissionDetails {
        label
        supportingLabels
        value
        filterSets
        matches
        hiddenMatches
        __typename
      }
      activityStream {
        id
        caseId
        text
        createdBy {
          id
          firstName
          lastName
          fullName
          guid
          userName
          audience
          personId
          photoURL
          photo
          mobilePhone
          email
          title
          __typename
        }
        createdOn
        locationNum

        ... on ActivityStreamComment {
          translatedText
        }
        ... on ActivityStreamAttachment {
          downloadURL
          fileName
          mimeType
        }
      }
      canRequestUpdate
      willCloseOn
      isUnread
      promptTypes
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.CasesQueryVariables, APITypes.CasesQuery>;
export const ticket = /* GraphQL */ `query Ticket($id: ID!, $markRead: Boolean) {
  ticket(id: $id, markRead: $markRead) {
    id
    number
    confidential
    status
    description
    longDescription
    assignedTo {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    contact {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    commentsAll
    openedOn
    updatedOn
    closedOn
    locationNum
    fieldMutated
    requestedItem {
      id
      number
      requestOptions {
        label
        supportingLabels
        value
        filterSets
        matches
        hiddenMatches
        __typename
      }
      __typename
    }
    submissionDetails {
      label
      supportingLabels
      value
      filterSets
      matches
      hiddenMatches
      __typename
    }
    activityStream {
      id
      caseId
      text
      createdBy {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      createdOn
      locationNum

      ... on ActivityStreamComment {
        translatedText
      }
      ... on ActivityStreamAttachment {
        downloadURL
        fileName
        mimeType
      }
    }
    canRequestUpdate
    willCloseOn
    isUnread
    promptTypes
    __typename
  }
}
` as GeneratedQuery<APITypes.TicketQueryVariables, APITypes.TicketQuery>;
export const casesRecent = /* GraphQL */ `query CasesRecent($locationNums: [String]!) {
  casesRecent(locationNums: $locationNums) {
    locationCasesRecent {
      locationNum
      cases {
        id
        number
        confidential
        status
        description
        longDescription
        assignedTo {
          id
          firstName
          lastName
          fullName
          guid
          userName
          audience
          personId
          photoURL
          photo
          mobilePhone
          email
          title
          __typename
        }
        contact {
          id
          firstName
          lastName
          fullName
          guid
          userName
          audience
          personId
          photoURL
          photo
          mobilePhone
          email
          title
          __typename
        }
        commentsAll
        openedOn
        updatedOn
        closedOn
        locationNum
        fieldMutated
        requestedItem {
          id
          number
          requestOptions {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          __typename
        }
        submissionDetails {
          label
          supportingLabels
          value
          filterSets
          matches
          hiddenMatches
          __typename
        }
        activityStream {
          id
          caseId
          text
          createdBy {
            id
            firstName
            lastName
            fullName
            guid
            userName
            audience
            personId
            photoURL
            photo
            mobilePhone
            email
            title
            __typename
          }
          createdOn
          locationNum

          ... on ActivityStreamComment {
            translatedText
          }
          ... on ActivityStreamAttachment {
            downloadURL
            fileName
            mimeType
          }
        }
        canRequestUpdate
        willCloseOn
        isUnread
        promptTypes
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CasesRecentQueryVariables,
  APITypes.CasesRecentQuery
>;
export const relatedCases = /* GraphQL */ `query RelatedCases($majorCaseId: ID!) {
  relatedCases(majorCaseId: $majorCaseId) {
    id
    number

    ... on MinorCaseType {
      locationNum
    }
    ... on SubmitFormResponseType {
      confirmationMessages
    }
    ... on AssetCaseType {
      description
    }
  }
}
` as GeneratedQuery<
  APITypes.RelatedCasesQueryVariables,
  APITypes.RelatedCasesQuery
>;
export const closeCaseReasons = /* GraphQL */ `query CloseCaseReasons {
  closeCaseReasons {
    label
    supportingLabels
    value
    filterSets
    matches
    hiddenMatches
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CloseCaseReasonsQueryVariables,
  APITypes.CloseCaseReasonsQuery
>;
export const casePrompts = /* GraphQL */ `query CasePrompts($caseId: ID!, $promptTypes: [CasePromptType]) {
  casePrompts(caseId: $caseId, promptTypes: $promptTypes) {
    id
    promptType
    title
    description

    ... on CasePromptViewAppointment {
      appointmentId
    }
  }
}
` as GeneratedQuery<
  APITypes.CasePromptsQueryVariables,
  APITypes.CasePromptsQuery
>;
export const supportCategories = /* GraphQL */ `query SupportCategories {
  supportCategories {
    id
    label
    description
    imageName
    url
    form {
      id
      minimumAppVersion
      introContents {
        header
        body {
          text
          imageName
          __typename
        }
        __typename
      }
      showIntroOnLoad
      dynamicLayout
      caseCategory
      defaults {
        id
        value
        displayValue
        description
        sensitive
        __typename
      }
      __typename
    }
    items {
      id
      label
      description
      imageName
      url
      form {
        id
        minimumAppVersion
        introContents {
          header
          body {
            text
            imageName
            __typename
          }
          __typename
        }
        showIntroOnLoad
        dynamicLayout
        caseCategory
        defaults {
          id
          value
          displayValue
          description
          sensitive
          __typename
        }
        __typename
      }
      items {
        id
        label
        description
        imageName
        url
        form {
          id
          minimumAppVersion
          introContents {
            header
            body {
              text
              imageName
              __typename
            }
            __typename
          }
          showIntroOnLoad
          dynamicLayout
          caseCategory
          defaults {
            id
            value
            displayValue
            description
            sensitive
            __typename
          }
          __typename
        }
        items {
          id
          label
          description
          imageName
          url
          form {
            id
            minimumAppVersion
            introContents {
              header
              body {
                text
                imageName
                __typename
              }
              __typename
            }
            showIntroOnLoad
            dynamicLayout
            caseCategory
            defaults {
              id
              value
              displayValue
              description
              sensitive
              __typename
            }
            __typename
          }
          items {
            id
            label
            description
            imageName
            url
            form {
              id
              minimumAppVersion
              introContents {
                header
                body {
                  text
                  imageName
                  __typename
                }
                __typename
              }
              showIntroOnLoad
              dynamicLayout
              caseCategory
              defaults {
                id
                value
                displayValue
                description
                sensitive
                __typename
              }
              __typename
            }
            items {
              id
              label
              description
              imageName
              url
              form {
                id
                minimumAppVersion
                introContents {
                  header
                  body {
                    text
                    imageName
                    __typename
                  }
                  __typename
                }
                showIntroOnLoad
                dynamicLayout
                caseCategory
                defaults {
                  id
                  value
                  displayValue
                  description
                  sensitive
                  __typename
                }
                __typename
              }
              items {
                id
                label
                description
                imageName
                url
                form {
                  id
                  minimumAppVersion
                  introContents {
                    header
                    body {
                      text
                      imageName
                      __typename
                    }
                    __typename
                  }
                  showIntroOnLoad
                  dynamicLayout
                  caseCategory
                  defaults {
                    id
                    value
                    displayValue
                    description
                    sensitive
                    __typename
                  }
                  __typename
                }
                items {
                  id
                  label
                  description
                  imageName
                  url
                  form {
                    id
                    minimumAppVersion
                    introContents {
                      header
                      __typename
                    }
                    showIntroOnLoad
                    dynamicLayout
                    caseCategory
                    defaults {
                      id
                      value
                      displayValue
                      description
                      sensitive
                      __typename
                    }
                    __typename
                  }
                  items {
                    id
                    label
                    description
                    imageName
                    url
                    form {
                      id
                      minimumAppVersion
                      showIntroOnLoad
                      dynamicLayout
                      caseCategory
                      __typename
                    }
                    items {
                      id
                      label
                      description
                      imageName
                      url
                      featuredOrder
                      recentlyFeaturedOrder
                      commonlyUsedOrder
                      recommendedOrder
                      isFeatured
                      labelAccoutrement
                      caseCategory
                      __typename
                    }
                    featuredOrder
                    recentlyFeaturedOrder
                    commonlyUsedOrder
                    recommendedOrder
                    isFeatured
                    labelAccoutrement
                    caseCategory
                    __typename
                  }
                  featuredOrder
                  recentlyFeaturedOrder
                  commonlyUsedOrder
                  recommendedOrder
                  isFeatured
                  labelAccoutrement
                  caseCategory
                  __typename
                }
                featuredOrder
                recentlyFeaturedOrder
                commonlyUsedOrder
                recommendedOrder
                isFeatured
                labelAccoutrement
                caseCategory
                __typename
              }
              featuredOrder
              recentlyFeaturedOrder
              commonlyUsedOrder
              recommendedOrder
              isFeatured
              labelAccoutrement
              caseCategory
              __typename
            }
            featuredOrder
            recentlyFeaturedOrder
            commonlyUsedOrder
            recommendedOrder
            isFeatured
            labelAccoutrement
            caseCategory
            __typename
          }
          featuredOrder
          recentlyFeaturedOrder
          commonlyUsedOrder
          recommendedOrder
          isFeatured
          labelAccoutrement
          caseCategory
          __typename
        }
        featuredOrder
        recentlyFeaturedOrder
        commonlyUsedOrder
        recommendedOrder
        isFeatured
        labelAccoutrement
        caseCategory
        __typename
      }
      featuredOrder
      recentlyFeaturedOrder
      commonlyUsedOrder
      recommendedOrder
      isFeatured
      labelAccoutrement
      caseCategory
      __typename
    }
    featuredOrder
    recentlyFeaturedOrder
    commonlyUsedOrder
    recommendedOrder
    isFeatured
    labelAccoutrement
    caseCategory
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SupportCategoriesQueryVariables,
  APITypes.SupportCategoriesQuery
>;
export const supportCategoriesAsset = /* GraphQL */ `query SupportCategoriesAsset($context: SupportCategoryContext) {
  supportCategoriesAsset(context: $context) {
    id
    label
    description
    imageName
    url
    form {
      id
      minimumAppVersion
      introContents {
        header
        body {
          text
          imageName
          __typename
        }
        __typename
      }
      showIntroOnLoad
      dynamicLayout
      caseCategory
      defaults {
        id
        value
        displayValue
        description
        sensitive
        __typename
      }
      __typename
    }
    items {
      id
      label
      description
      imageName
      url
      form {
        id
        minimumAppVersion
        introContents {
          header
          body {
            text
            imageName
            __typename
          }
          __typename
        }
        showIntroOnLoad
        dynamicLayout
        caseCategory
        defaults {
          id
          value
          displayValue
          description
          sensitive
          __typename
        }
        __typename
      }
      items {
        id
        label
        description
        imageName
        url
        form {
          id
          minimumAppVersion
          introContents {
            header
            body {
              text
              imageName
              __typename
            }
            __typename
          }
          showIntroOnLoad
          dynamicLayout
          caseCategory
          defaults {
            id
            value
            displayValue
            description
            sensitive
            __typename
          }
          __typename
        }
        items {
          id
          label
          description
          imageName
          url
          form {
            id
            minimumAppVersion
            introContents {
              header
              body {
                text
                imageName
                __typename
              }
              __typename
            }
            showIntroOnLoad
            dynamicLayout
            caseCategory
            defaults {
              id
              value
              displayValue
              description
              sensitive
              __typename
            }
            __typename
          }
          items {
            id
            label
            description
            imageName
            url
            form {
              id
              minimumAppVersion
              introContents {
                header
                body {
                  text
                  imageName
                  __typename
                }
                __typename
              }
              showIntroOnLoad
              dynamicLayout
              caseCategory
              defaults {
                id
                value
                displayValue
                description
                sensitive
                __typename
              }
              __typename
            }
            items {
              id
              label
              description
              imageName
              url
              form {
                id
                minimumAppVersion
                introContents {
                  header
                  body {
                    text
                    imageName
                    __typename
                  }
                  __typename
                }
                showIntroOnLoad
                dynamicLayout
                caseCategory
                defaults {
                  id
                  value
                  displayValue
                  description
                  sensitive
                  __typename
                }
                __typename
              }
              items {
                id
                label
                description
                imageName
                url
                form {
                  id
                  minimumAppVersion
                  introContents {
                    header
                    body {
                      text
                      imageName
                      __typename
                    }
                    __typename
                  }
                  showIntroOnLoad
                  dynamicLayout
                  caseCategory
                  defaults {
                    id
                    value
                    displayValue
                    description
                    sensitive
                    __typename
                  }
                  __typename
                }
                items {
                  id
                  label
                  description
                  imageName
                  url
                  form {
                    id
                    minimumAppVersion
                    introContents {
                      header
                      __typename
                    }
                    showIntroOnLoad
                    dynamicLayout
                    caseCategory
                    defaults {
                      id
                      value
                      displayValue
                      description
                      sensitive
                      __typename
                    }
                    __typename
                  }
                  items {
                    id
                    label
                    description
                    imageName
                    url
                    form {
                      id
                      minimumAppVersion
                      showIntroOnLoad
                      dynamicLayout
                      caseCategory
                      __typename
                    }
                    items {
                      id
                      label
                      description
                      imageName
                      url
                      featuredOrder
                      recentlyFeaturedOrder
                      commonlyUsedOrder
                      recommendedOrder
                      isFeatured
                      labelAccoutrement
                      caseCategory
                      __typename
                    }
                    featuredOrder
                    recentlyFeaturedOrder
                    commonlyUsedOrder
                    recommendedOrder
                    isFeatured
                    labelAccoutrement
                    caseCategory
                    __typename
                  }
                  featuredOrder
                  recentlyFeaturedOrder
                  commonlyUsedOrder
                  recommendedOrder
                  isFeatured
                  labelAccoutrement
                  caseCategory
                  __typename
                }
                featuredOrder
                recentlyFeaturedOrder
                commonlyUsedOrder
                recommendedOrder
                isFeatured
                labelAccoutrement
                caseCategory
                __typename
              }
              featuredOrder
              recentlyFeaturedOrder
              commonlyUsedOrder
              recommendedOrder
              isFeatured
              labelAccoutrement
              caseCategory
              __typename
            }
            featuredOrder
            recentlyFeaturedOrder
            commonlyUsedOrder
            recommendedOrder
            isFeatured
            labelAccoutrement
            caseCategory
            __typename
          }
          featuredOrder
          recentlyFeaturedOrder
          commonlyUsedOrder
          recommendedOrder
          isFeatured
          labelAccoutrement
          caseCategory
          __typename
        }
        featuredOrder
        recentlyFeaturedOrder
        commonlyUsedOrder
        recommendedOrder
        isFeatured
        labelAccoutrement
        caseCategory
        __typename
      }
      featuredOrder
      recentlyFeaturedOrder
      commonlyUsedOrder
      recommendedOrder
      isFeatured
      labelAccoutrement
      caseCategory
      __typename
    }
    featuredOrder
    recentlyFeaturedOrder
    commonlyUsedOrder
    recommendedOrder
    isFeatured
    labelAccoutrement
    caseCategory
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SupportCategoriesAssetQueryVariables,
  APITypes.SupportCategoriesAssetQuery
>;
export const supportCategoryItem = /* GraphQL */ `query SupportCategoryItem($id: ID!) {
  supportCategoryItem(id: $id) {
    id
    label
    description
    imageName
    url
    form {
      id
      minimumAppVersion
      introContents {
        header
        body {
          text
          imageName
          __typename
        }
        __typename
      }
      showIntroOnLoad
      dynamicLayout
      caseCategory
      defaults {
        id
        value
        displayValue
        description
        sensitive
        __typename
      }
      __typename
    }
    items {
      id
      label
      description
      imageName
      url
      form {
        id
        minimumAppVersion
        introContents {
          header
          body {
            text
            imageName
            __typename
          }
          __typename
        }
        showIntroOnLoad
        dynamicLayout
        caseCategory
        defaults {
          id
          value
          displayValue
          description
          sensitive
          __typename
        }
        __typename
      }
      items {
        id
        label
        description
        imageName
        url
        form {
          id
          minimumAppVersion
          introContents {
            header
            body {
              text
              imageName
              __typename
            }
            __typename
          }
          showIntroOnLoad
          dynamicLayout
          caseCategory
          defaults {
            id
            value
            displayValue
            description
            sensitive
            __typename
          }
          __typename
        }
        items {
          id
          label
          description
          imageName
          url
          form {
            id
            minimumAppVersion
            introContents {
              header
              body {
                text
                imageName
                __typename
              }
              __typename
            }
            showIntroOnLoad
            dynamicLayout
            caseCategory
            defaults {
              id
              value
              displayValue
              description
              sensitive
              __typename
            }
            __typename
          }
          items {
            id
            label
            description
            imageName
            url
            form {
              id
              minimumAppVersion
              introContents {
                header
                body {
                  text
                  imageName
                  __typename
                }
                __typename
              }
              showIntroOnLoad
              dynamicLayout
              caseCategory
              defaults {
                id
                value
                displayValue
                description
                sensitive
                __typename
              }
              __typename
            }
            items {
              id
              label
              description
              imageName
              url
              form {
                id
                minimumAppVersion
                introContents {
                  header
                  body {
                    text
                    imageName
                    __typename
                  }
                  __typename
                }
                showIntroOnLoad
                dynamicLayout
                caseCategory
                defaults {
                  id
                  value
                  displayValue
                  description
                  sensitive
                  __typename
                }
                __typename
              }
              items {
                id
                label
                description
                imageName
                url
                form {
                  id
                  minimumAppVersion
                  introContents {
                    header
                    body {
                      text
                      imageName
                      __typename
                    }
                    __typename
                  }
                  showIntroOnLoad
                  dynamicLayout
                  caseCategory
                  defaults {
                    id
                    value
                    displayValue
                    description
                    sensitive
                    __typename
                  }
                  __typename
                }
                items {
                  id
                  label
                  description
                  imageName
                  url
                  form {
                    id
                    minimumAppVersion
                    introContents {
                      header
                      __typename
                    }
                    showIntroOnLoad
                    dynamicLayout
                    caseCategory
                    defaults {
                      id
                      value
                      displayValue
                      description
                      sensitive
                      __typename
                    }
                    __typename
                  }
                  items {
                    id
                    label
                    description
                    imageName
                    url
                    form {
                      id
                      minimumAppVersion
                      showIntroOnLoad
                      dynamicLayout
                      caseCategory
                      __typename
                    }
                    items {
                      id
                      label
                      description
                      imageName
                      url
                      featuredOrder
                      recentlyFeaturedOrder
                      commonlyUsedOrder
                      recommendedOrder
                      isFeatured
                      labelAccoutrement
                      caseCategory
                      __typename
                    }
                    featuredOrder
                    recentlyFeaturedOrder
                    commonlyUsedOrder
                    recommendedOrder
                    isFeatured
                    labelAccoutrement
                    caseCategory
                    __typename
                  }
                  featuredOrder
                  recentlyFeaturedOrder
                  commonlyUsedOrder
                  recommendedOrder
                  isFeatured
                  labelAccoutrement
                  caseCategory
                  __typename
                }
                featuredOrder
                recentlyFeaturedOrder
                commonlyUsedOrder
                recommendedOrder
                isFeatured
                labelAccoutrement
                caseCategory
                __typename
              }
              featuredOrder
              recentlyFeaturedOrder
              commonlyUsedOrder
              recommendedOrder
              isFeatured
              labelAccoutrement
              caseCategory
              __typename
            }
            featuredOrder
            recentlyFeaturedOrder
            commonlyUsedOrder
            recommendedOrder
            isFeatured
            labelAccoutrement
            caseCategory
            __typename
          }
          featuredOrder
          recentlyFeaturedOrder
          commonlyUsedOrder
          recommendedOrder
          isFeatured
          labelAccoutrement
          caseCategory
          __typename
        }
        featuredOrder
        recentlyFeaturedOrder
        commonlyUsedOrder
        recommendedOrder
        isFeatured
        labelAccoutrement
        caseCategory
        __typename
      }
      featuredOrder
      recentlyFeaturedOrder
      commonlyUsedOrder
      recommendedOrder
      isFeatured
      labelAccoutrement
      caseCategory
      __typename
    }
    featuredOrder
    recentlyFeaturedOrder
    commonlyUsedOrder
    recommendedOrder
    isFeatured
    labelAccoutrement
    caseCategory
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SupportCategoryItemQueryVariables,
  APITypes.SupportCategoryItemQuery
>;
export const supportContext = /* GraphQL */ `query SupportContext($caseNumber: String!) {
  supportContext(caseNumber: $caseNumber) {
    supportDeskPhoneNumber
    queue {
      isOpen
      personsInQueueCount
      routingKey
      __typename
    }
    assignedTo
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SupportContextQueryVariables,
  APITypes.SupportContextQuery
>;
export const announcements = /* GraphQL */ `query Announcements {
  announcements {
    id
    title
    summary
    category
    updatedOn
    hasBeenUpdated
    url
    outagePageURL
    majorCaseId
    isUnread
    isExpired
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AnnouncementsQueryVariables,
  APITypes.AnnouncementsQuery
>;
export const request = /* GraphQL */ `query Request($caseNumber: String!, $requestedItemNumber: String) {
  request(caseNumber: $caseNumber, requestedItemNumber: $requestedItemNumber) {
    number
    details {
      label
      supportingLabels
      value
      filterSets
      matches
      hiddenMatches
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.RequestQueryVariables, APITypes.RequestQuery>;
export const secureServiceNowLink = /* GraphQL */ `query SecureServiceNowLink($unsecureLink: String!) {
  secureServiceNowLink(unsecureLink: $unsecureLink)
}
` as GeneratedQuery<
  APITypes.SecureServiceNowLinkQueryVariables,
  APITypes.SecureServiceNowLinkQuery
>;
export const kbFeedbackReasons = /* GraphQL */ `query KbFeedbackReasons {
  kbFeedbackReasons {
    label
    supportingLabels
    value
    filterSets
    matches
    hiddenMatches
    __typename
  }
}
` as GeneratedQuery<
  APITypes.KbFeedbackReasonsQueryVariables,
  APITypes.KbFeedbackReasonsQuery
>;
export const kbArticle = /* GraphQL */ `query KbArticle(
  $id: ID!
  $trackView: Boolean
  $foundViaQueryId: ID
  $foundViaResultId: ID
) {
  kbArticle(
    id: $id
    trackView: $trackView
    foundViaQueryId: $foundViaQueryId
    foundViaResultId: $foundViaResultId
  ) {
    id
    number
    title
    solutionContent
    visibility
    preview
    searchQueryId
    searchResultId
    __typename
  }
}
` as GeneratedQuery<APITypes.KbArticleQueryVariables, APITypes.KbArticleQuery>;
export const kbArticlesRecent = /* GraphQL */ `query KbArticlesRecent {
  kbArticlesRecent {
    id
    number
    title
    solutionContent
    visibility
    preview
    searchQueryId
    searchResultId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.KbArticlesRecentQueryVariables,
  APITypes.KbArticlesRecentQuery
>;
export const kbArticlesFeatured = /* GraphQL */ `query KbArticlesFeatured {
  kbArticlesFeatured {
    id
    number
    title
    solutionContent
    visibility
    preview
    searchQueryId
    searchResultId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.KbArticlesFeaturedQueryVariables,
  APITypes.KbArticlesFeaturedQuery
>;
export const kbArticlesAnswers = /* GraphQL */ `query KbArticlesAnswers {
  kbArticlesAnswers {
    articlesFeatured {
      id
      number
      title
      solutionContent
      visibility
      preview
      searchQueryId
      searchResultId
      __typename
    }
    articlesRecent {
      id
      number
      title
      solutionContent
      visibility
      preview
      searchQueryId
      searchResultId
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.KbArticlesAnswersQueryVariables,
  APITypes.KbArticlesAnswersQuery
>;
export const airshipUserProperties = /* GraphQL */ `query AirshipUserProperties($namedUserGuid: String) {
  airshipUserProperties(namedUserGuid: $namedUserGuid) {
    tagGroups {
      name
      tags
      __typename
    }
    attributes {
      label
      supportingLabels
      value
      filterSets
      matches
      hiddenMatches
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AirshipUserPropertiesQueryVariables,
  APITypes.AirshipUserPropertiesQuery
>;
export const userInfo = /* GraphQL */ `query UserInfo {
  userInfo {
    user {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    countryCode
    __typename
  }
}
` as GeneratedQuery<APITypes.UserInfoQueryVariables, APITypes.UserInfoQuery>;
export const userEventInfo = /* GraphQL */ `query UserEventInfo($eventType: String!, $filter: UserEventFilter) {
  userEventInfo(eventType: $eventType, filter: $filter) {
    userGuid
    eventType
    count
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserEventInfoQueryVariables,
  APITypes.UserEventInfoQuery
>;
export const restaurant = /* GraphQL */ `query Restaurant($locationNum: String!) {
  restaurant(locationNum: $locationNum) {
    id
    number
    name
    contacts {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    siteProperties {
      lat
      long
      countryCode
      utcOffset
      tzId
      __typename
    }
    openCasesCount
    operator {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    supportDeskPhoneNumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RestaurantQueryVariables,
  APITypes.RestaurantQuery
>;
export const restaurants = /* GraphQL */ `query Restaurants($contains: String) {
  restaurants(contains: $contains) {
    id
    number
    name
    contacts {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    siteProperties {
      lat
      long
      countryCode
      utcOffset
      tzId
      __typename
    }
    openCasesCount
    operator {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    supportDeskPhoneNumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RestaurantsQueryVariables,
  APITypes.RestaurantsQuery
>;
export const restaurantsRecent = /* GraphQL */ `query RestaurantsRecent($userGuid: String!) {
  restaurantsRecent(userGuid: $userGuid) {
    id
    number
    name
    contacts {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    siteProperties {
      lat
      long
      countryCode
      utcOffset
      tzId
      __typename
    }
    openCasesCount
    operator {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    supportDeskPhoneNumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RestaurantsRecentQueryVariables,
  APITypes.RestaurantsRecentQuery
>;
export const restaurantsAssigned = /* GraphQL */ `query RestaurantsAssigned($consultantGuid: String!) {
  restaurantsAssigned(consultantGuid: $consultantGuid) {
    id
    number
    name
    contacts {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    siteProperties {
      lat
      long
      countryCode
      utcOffset
      tzId
      __typename
    }
    openCasesCount
    operator {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    supportDeskPhoneNumber
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RestaurantsAssignedQueryVariables,
  APITypes.RestaurantsAssignedQuery
>;
export const restaurantsStaff = /* GraphQL */ `query RestaurantsStaff($userGuid: String!) {
  restaurantsStaff(userGuid: $userGuid) {
    type
    restaurants {
      id
      number
      name
      contacts {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      siteProperties {
        lat
        long
        countryCode
        utcOffset
        tzId
        __typename
      }
      openCasesCount
      operator {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      supportDeskPhoneNumber
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RestaurantsStaffQueryVariables,
  APITypes.RestaurantsStaffQuery
>;
export const supportAppConfig = /* GraphQL */ `query SupportAppConfig {
  supportAppConfig {
    label
    supportingLabels
    value
    filterSets
    matches
    hiddenMatches
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SupportAppConfigQueryVariables,
  APITypes.SupportAppConfigQuery
>;
export const userHasRole = /* GraphQL */ `query UserHasRole($role: String!) {
  userHasRole(role: $role)
}
` as GeneratedQuery<
  APITypes.UserHasRoleQueryVariables,
  APITypes.UserHasRoleQuery
>;
export const formLayout = /* GraphQL */ `query FormLayout($id: ID!, $locationNum: String, $defaults: [FormVariable]) {
  formLayout(id: $id, locationNum: $locationNum, defaults: $defaults) {
    id
    version
    title
    usesAttachments
    confirmationMessages
    layout {
      id
      title
      header
      footer
      groups {
        id
        header
        footer
        fields {
          id
          fieldType
          visible
          align
          header
          footer
          footerEmphasized
          styles {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          variesBasedOn
          variants {
            key
            changes {
              header
              visible
              disabled
              required
              text
              nextStage
              content
              input {
                current {
                  label
                  supportingLabels
                  value
                  filterSets
                  matches
                  hiddenMatches
                  __typename
                }
                options {
                  label
                  supportingLabels
                  value
                  filterSets
                  matches
                  hiddenMatches
                  __typename
                }
                __typename
              }
              __typename
            }
            __typename
          }
          resetBasedOnAny

          ... on FormLayoutInteractionField {
            usageInstructions
            required
          }
          ... on FormLayoutReadOnlyField {
            text
          }
          ... on FormLayoutInputField {
            submissionField
            alternateSubmissionField
            disabled
            required
            inputProperties {
              current {
                label
                supportingLabels
                value
                filterSets
                matches
                hiddenMatches
                __typename
              }

              ... on FormLayoutInputFieldInputDate {
                format
                disabled
                ruleSet
                defaultDate
                startDate
                endDate
                excludedDates
              }
              ... on FormLayoutInputFieldInputPhone {
                mask
                placeholderText
              }
              ... on FormLayoutInputFieldInputTextTypeahead {
                placeholderText
                maxLines
                maxCharacters
                query
              }
              ... on FormLayoutInputFieldInputSelect {
                options {
                  label
                  supportingLabels
                  value
                  filterSets
                  matches
                  hiddenMatches
                  __typename
                }
                interactionType
                namedSupportingText
                genericSupportingText
                manualEntryRoute
                manualEntryStage
                manualOption {
                  label
                  supportingLabels
                  value
                  filterSets
                  matches
                  hiddenMatches
                  __typename
                }
                preSearchText
                filters {
                  label
                  subLabel
                  keyword
                  sortStrategy
                  __typename
                }
                sortStrategy
              }
              ... on FormLayoutInputFieldInputMultiSelectSearch {
                options {
                  label
                  supportingLabels
                  value
                  filterSets
                  matches
                  hiddenMatches
                  __typename
                }
                placeholderText
                searchHeader
                searchPlaceholderText
                sortStrategy
              }
              ... on FormLayoutInputFieldInputText {
                placeholderText
                minCharacters
                maxLines
                maxCharacters
                hideMaxCharactersCount
                keyboard
                minNumericValue
              }
              ... on FormLayoutInputFieldInputMultiSelect {
                options {
                  label
                  supportingLabels
                  value
                  filterSets
                  matches
                  hiddenMatches
                  __typename
                }
                placeholderText
              }
              ... on FormLayoutInputFieldInputTime {
                ruleSet
                format
              }
            }
          }
          ... on FormLayoutTableField {
            content
          }
        }
        styles {
          label
          supportingLabels
          value
          filterSets
          matches
          hiddenMatches
          __typename
        }
        submissionFields
        orientation
        required
        __typename
      }
      styles {
        label
        supportingLabels
        value
        filterSets
        matches
        hiddenMatches
        __typename
      }
      submissionFields
      required
      proceedOnAnyRequired
      visible
      supportingData
      nextStage
      variesBasedOn
      variants {
        key
        changes {
          header
          visible
          disabled
          required
          text
          nextStage
          content
          input {
            current {
              label
              supportingLabels
              value
              filterSets
              matches
              hiddenMatches
              __typename
            }
            options {
              label
              supportingLabels
              value
              filterSets
              matches
              hiddenMatches
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      asides {
        id
        header
        footer
        groups {
          id
          header
          footer
          fields {
            id
            fieldType
            visible
            align
            header
            footer
            footerEmphasized
            styles {
              label
              supportingLabels
              value
              filterSets
              matches
              hiddenMatches
              __typename
            }
            variesBasedOn
            variants {
              key
              changes {
                header
                visible
                disabled
                required
                text
                nextStage
                content
                input {
                  current {
                    label
                    supportingLabels
                    value
                    filterSets
                    matches
                    hiddenMatches
                    __typename
                  }
                  options {
                    label
                    supportingLabels
                    value
                    filterSets
                    matches
                    hiddenMatches
                    __typename
                  }
                  __typename
                }
                __typename
              }
              __typename
            }
            resetBasedOnAny

            ... on FormLayoutInteractionField {
              usageInstructions
              required
            }
            ... on FormLayoutReadOnlyField {
              text
            }
            ... on FormLayoutInputField {
              submissionField
              alternateSubmissionField
              disabled
              required
              inputProperties {
                current {
                  label
                  supportingLabels
                  value
                  filterSets
                  matches
                  hiddenMatches
                  __typename
                }

                ... on FormLayoutInputFieldInputDate {
                  format
                  disabled
                  ruleSet
                  defaultDate
                  startDate
                  endDate
                  excludedDates
                }
                ... on FormLayoutInputFieldInputPhone {
                  mask
                  placeholderText
                }
                ... on FormLayoutInputFieldInputTextTypeahead {
                  placeholderText
                  maxLines
                  maxCharacters
                  query
                }
                ... on FormLayoutInputFieldInputSelect {
                  options {
                    label
                    supportingLabels
                    value
                    filterSets
                    matches
                    hiddenMatches
                    __typename
                  }
                  interactionType
                  namedSupportingText
                  genericSupportingText
                  manualEntryRoute
                  manualEntryStage
                  manualOption {
                    label
                    supportingLabels
                    value
                    filterSets
                    matches
                    hiddenMatches
                    __typename
                  }
                  preSearchText
                  filters {
                    label
                    subLabel
                    keyword
                    sortStrategy
                    __typename
                  }
                  sortStrategy
                }
                ... on FormLayoutInputFieldInputMultiSelectSearch {
                  options {
                    label
                    supportingLabels
                    value
                    filterSets
                    matches
                    hiddenMatches
                    __typename
                  }
                  placeholderText
                  searchHeader
                  searchPlaceholderText
                  sortStrategy
                }
                ... on FormLayoutInputFieldInputText {
                  placeholderText
                  minCharacters
                  maxLines
                  maxCharacters
                  hideMaxCharactersCount
                  keyboard
                  minNumericValue
                }
                ... on FormLayoutInputFieldInputMultiSelect {
                  options {
                    label
                    supportingLabels
                    value
                    filterSets
                    matches
                    hiddenMatches
                    __typename
                  }
                  placeholderText
                }
                ... on FormLayoutInputFieldInputTime {
                  ruleSet
                  format
                }
              }
            }
            ... on FormLayoutTableField {
              content
            }
          }
          styles {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          submissionFields
          orientation
          required
          __typename
        }
        styles {
          label
          supportingLabels
          value
          filterSets
          matches
          hiddenMatches
          __typename
        }
        __typename
      }
      __typename
    }
    variables {
      id
      value
      displayValue
      description
      sensitive
      __typename
    }
    startingStage
    reloadOnLocationChange
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FormLayoutQueryVariables,
  APITypes.FormLayoutQuery
>;
export const searchAllSupport = /* GraphQL */ `query SearchAllSupport(
  $contains: String!
  $context: [SupportSearchContext]
  $ignoreTrackSearch: Boolean
) {
  searchAllSupport(
    contains: $contains
    context: $context
    ignoreTrackSearch: $ignoreTrackSearch
  ) {
    articles {
      id
      number
      title
      solutionContent
      visibility
      preview
      searchQueryId
      searchResultId
      __typename
    }
    forms {
      id
      label
      description
      imageName
      url
      form {
        id
        minimumAppVersion
        introContents {
          header
          body {
            text
            imageName
            __typename
          }
          __typename
        }
        showIntroOnLoad
        dynamicLayout
        caseCategory
        defaults {
          id
          value
          displayValue
          description
          sensitive
          __typename
        }
        __typename
      }
      items {
        id
        label
        description
        imageName
        url
        form {
          id
          minimumAppVersion
          introContents {
            header
            body {
              text
              imageName
              __typename
            }
            __typename
          }
          showIntroOnLoad
          dynamicLayout
          caseCategory
          defaults {
            id
            value
            displayValue
            description
            sensitive
            __typename
          }
          __typename
        }
        items {
          id
          label
          description
          imageName
          url
          form {
            id
            minimumAppVersion
            introContents {
              header
              body {
                text
                imageName
                __typename
              }
              __typename
            }
            showIntroOnLoad
            dynamicLayout
            caseCategory
            defaults {
              id
              value
              displayValue
              description
              sensitive
              __typename
            }
            __typename
          }
          items {
            id
            label
            description
            imageName
            url
            form {
              id
              minimumAppVersion
              introContents {
                header
                body {
                  text
                  imageName
                  __typename
                }
                __typename
              }
              showIntroOnLoad
              dynamicLayout
              caseCategory
              defaults {
                id
                value
                displayValue
                description
                sensitive
                __typename
              }
              __typename
            }
            items {
              id
              label
              description
              imageName
              url
              form {
                id
                minimumAppVersion
                introContents {
                  header
                  body {
                    text
                    imageName
                    __typename
                  }
                  __typename
                }
                showIntroOnLoad
                dynamicLayout
                caseCategory
                defaults {
                  id
                  value
                  displayValue
                  description
                  sensitive
                  __typename
                }
                __typename
              }
              items {
                id
                label
                description
                imageName
                url
                form {
                  id
                  minimumAppVersion
                  introContents {
                    header
                    body {
                      text
                      imageName
                      __typename
                    }
                    __typename
                  }
                  showIntroOnLoad
                  dynamicLayout
                  caseCategory
                  defaults {
                    id
                    value
                    displayValue
                    description
                    sensitive
                    __typename
                  }
                  __typename
                }
                items {
                  id
                  label
                  description
                  imageName
                  url
                  form {
                    id
                    minimumAppVersion
                    introContents {
                      header
                      __typename
                    }
                    showIntroOnLoad
                    dynamicLayout
                    caseCategory
                    defaults {
                      id
                      value
                      displayValue
                      description
                      sensitive
                      __typename
                    }
                    __typename
                  }
                  items {
                    id
                    label
                    description
                    imageName
                    url
                    form {
                      id
                      minimumAppVersion
                      showIntroOnLoad
                      dynamicLayout
                      caseCategory
                      __typename
                    }
                    items {
                      id
                      label
                      description
                      imageName
                      url
                      featuredOrder
                      recentlyFeaturedOrder
                      commonlyUsedOrder
                      recommendedOrder
                      isFeatured
                      labelAccoutrement
                      caseCategory
                      __typename
                    }
                    featuredOrder
                    recentlyFeaturedOrder
                    commonlyUsedOrder
                    recommendedOrder
                    isFeatured
                    labelAccoutrement
                    caseCategory
                    __typename
                  }
                  featuredOrder
                  recentlyFeaturedOrder
                  commonlyUsedOrder
                  recommendedOrder
                  isFeatured
                  labelAccoutrement
                  caseCategory
                  __typename
                }
                featuredOrder
                recentlyFeaturedOrder
                commonlyUsedOrder
                recommendedOrder
                isFeatured
                labelAccoutrement
                caseCategory
                __typename
              }
              featuredOrder
              recentlyFeaturedOrder
              commonlyUsedOrder
              recommendedOrder
              isFeatured
              labelAccoutrement
              caseCategory
              __typename
            }
            featuredOrder
            recentlyFeaturedOrder
            commonlyUsedOrder
            recommendedOrder
            isFeatured
            labelAccoutrement
            caseCategory
            __typename
          }
          featuredOrder
          recentlyFeaturedOrder
          commonlyUsedOrder
          recommendedOrder
          isFeatured
          labelAccoutrement
          caseCategory
          __typename
        }
        featuredOrder
        recentlyFeaturedOrder
        commonlyUsedOrder
        recommendedOrder
        isFeatured
        labelAccoutrement
        caseCategory
        __typename
      }
      featuredOrder
      recentlyFeaturedOrder
      commonlyUsedOrder
      recommendedOrder
      isFeatured
      labelAccoutrement
      caseCategory
      __typename
    }
    searchResultCases {
      id
      number
      status
      description
      longDescription
      commentPreview
      openedOn
      updatedOn
      confidential
      locationNum
      contact {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchAllSupportQueryVariables,
  APITypes.SearchAllSupportQuery
>;
export const searchCases = /* GraphQL */ `query SearchCases($contains: String!, $filters: SearchCaseFilters) {
  searchCases(contains: $contains, filters: $filters) {
    id
    number
    status
    description
    longDescription
    commentPreview
    openedOn
    updatedOn
    confidential
    locationNum
    contact {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchCasesQueryVariables,
  APITypes.SearchCasesQuery
>;
export const searchesRecent = /* GraphQL */ `query SearchesRecent($userGuid: String!) {
  searchesRecent(userGuid: $userGuid)
}
` as GeneratedQuery<
  APITypes.SearchesRecentQueryVariables,
  APITypes.SearchesRecentQuery
>;
export const appointments = /* GraphQL */ `query Appointments($locationNums: [String]) {
  appointments(locationNums: $locationNums) {
    id
    caseNumber
    subject
    description
    contact
    status
    dueDate
    technician {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    restaurant {
      id
      number
      name
      contacts {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      siteProperties {
        lat
        long
        countryCode
        utcOffset
        tzId
        __typename
      }
      openCasesCount
      operator {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      supportDeskPhoneNumber
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentsQueryVariables,
  APITypes.AppointmentsQuery
>;
export const appointment = /* GraphQL */ `query Appointment($id: ID!) {
  appointment(id: $id) {
    id
    caseNumber
    subject
    description
    contact
    status
    dueDate
    technician {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    restaurant {
      id
      number
      name
      contacts {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      siteProperties {
        lat
        long
        countryCode
        utcOffset
        tzId
        __typename
      }
      openCasesCount
      operator {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      supportDeskPhoneNumber
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AppointmentQueryVariables,
  APITypes.AppointmentQuery
>;
export const programMemberships = /* GraphQL */ `query ProgramMemberships($locationNums: [String], $userGuid: String) {
  programMemberships(locationNums: $locationNums, userGuid: $userGuid) {
    locationMemberships {
      program
      locationNum
      __typename
    }
    userMemberships {
      program
      guid
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProgramMembershipsQueryVariables,
  APITypes.ProgramMembershipsQuery
>;
export const asset = /* GraphQL */ `query Asset($tag: ID!, $markViewed: Boolean) {
  asset(tag: $tag, markViewed: $markViewed) {
    id
    tag
    csiCode
    serial
    name
    locationNum
    type {
      id
      name
      imageURL
      family
      __typename
    }
    model {
      id
      imageURL
      allowAdditionalEquipmentRequest
      __typename
    }
    manufacturer
    relatedCases {
      id
      number

      ... on MinorCaseType {
        locationNum
      }
      ... on SubmitFormResponseType {
        confirmationMessages
      }
      ... on AssetCaseType {
        description
      }
    }
    department
    resources {
      key
      externalURL
      imageName
      label
      __typename
    }
    flowInfo {
      flowId
      flowName
      title
      description
      thumbnailImageURL
      minimumAppVersion
      __typename
    }
    flowInfos {
      flowId
      flowName
      title
      description
      thumbnailImageURL
      minimumAppVersion
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.AssetQueryVariables, APITypes.AssetQuery>;
export const assetById = /* GraphQL */ `query AssetById($id: ID!, $markViewed: Boolean) {
  assetById(id: $id, markViewed: $markViewed) {
    id
    tag
    csiCode
    serial
    name
    locationNum
    type {
      id
      name
      imageURL
      family
      __typename
    }
    model {
      id
      imageURL
      allowAdditionalEquipmentRequest
      __typename
    }
    manufacturer
    relatedCases {
      id
      number

      ... on MinorCaseType {
        locationNum
      }
      ... on SubmitFormResponseType {
        confirmationMessages
      }
      ... on AssetCaseType {
        description
      }
    }
    department
    resources {
      key
      externalURL
      imageName
      label
      __typename
    }
    flowInfo {
      flowId
      flowName
      title
      description
      thumbnailImageURL
      minimumAppVersion
      __typename
    }
    flowInfos {
      flowId
      flowName
      title
      description
      thumbnailImageURL
      minimumAppVersion
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.AssetByIdQueryVariables, APITypes.AssetByIdQuery>;
export const assets = /* GraphQL */ `query Assets($locationNums: [String]!, $csiCode: String) {
  assets(locationNums: $locationNums, csiCode: $csiCode) {
    id
    tag
    csiCode
    serial
    name
    locationNum
    type {
      id
      name
      imageURL
      family
      __typename
    }
    model {
      id
      imageURL
      allowAdditionalEquipmentRequest
      __typename
    }
    manufacturer
    relatedCases {
      id
      number

      ... on MinorCaseType {
        locationNum
      }
      ... on SubmitFormResponseType {
        confirmationMessages
      }
      ... on AssetCaseType {
        description
      }
    }
    department
    resources {
      key
      externalURL
      imageName
      label
      __typename
    }
    flowInfo {
      flowId
      flowName
      title
      description
      thumbnailImageURL
      minimumAppVersion
      __typename
    }
    flowInfos {
      flowId
      flowName
      title
      description
      thumbnailImageURL
      minimumAppVersion
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.AssetsQueryVariables, APITypes.AssetsQuery>;
export const assetsRecent = /* GraphQL */ `query AssetsRecent($userGuid: String!) {
  assetsRecent(userGuid: $userGuid) {
    id
    tag
    serial
    locationNum
    viewedOn
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssetsRecentQueryVariables,
  APITypes.AssetsRecentQuery
>;
export const assetAlert = /* GraphQL */ `query AssetAlert($id: ID!) {
  assetAlert(id: $id) {
    id
    locationNum
    locationName
    action
    actor
    createdOn
    summary
    deviceType
    detail {
      label
      supportingLabels
      value
      filterSets
      matches
      hiddenMatches
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssetAlertQueryVariables,
  APITypes.AssetAlertQuery
>;
export const assetResources = /* GraphQL */ `query AssetResources($locationNum: String!) {
  assetResources(locationNum: $locationNum) {
    key
    externalURL
    imageName
    label
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssetResourcesQueryVariables,
  APITypes.AssetResourcesQuery
>;
export const assetWarranties = /* GraphQL */ `query AssetWarranties($assetId: ID!) {
  assetWarranties(assetId: $assetId) {
    id
    type
    name
    status
    expiresOn
    termMonths
    coverage {
      header
      body
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssetWarrantiesQueryVariables,
  APITypes.AssetWarrantiesQuery
>;
export const assetServiceHistory = /* GraphQL */ `query AssetServiceHistory($assetId: ID!, $locationNum: String!) {
  assetServiceHistory(assetId: $assetId, locationNum: $locationNum) {
    assetId
    locationNum
    events {
      id
      assetId
      locationNum
      status
      costUSD
      serviceDate
      issue
      resolution
      technicianName
      source
      vendor
      createdOn
      updatedOn
      createdBy {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      updatedBy {
        id
        firstName
        lastName
        fullName
        guid
        userName
        audience
        personId
        photoURL
        photo
        mobilePhone
        email
        title
        __typename
      }
      attachments {
        id
        fileName
        mimeType
        downloadUrl
        scheme
        __typename
      }
      __typename
    }
    totalCostUSD
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssetServiceHistoryQueryVariables,
  APITypes.AssetServiceHistoryQuery
>;
export const assetServiceEvent = /* GraphQL */ `query AssetServiceEvent($eventId: ID!) {
  assetServiceEvent(eventId: $eventId) {
    id
    assetId
    locationNum
    status
    costUSD
    serviceDate
    issue
    resolution
    technicianName
    source
    vendor
    createdOn
    updatedOn
    createdBy {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    updatedBy {
      id
      firstName
      lastName
      fullName
      guid
      userName
      audience
      personId
      photoURL
      photo
      mobilePhone
      email
      title
      __typename
    }
    attachments {
      id
      fileName
      mimeType
      downloadUrl
      scheme
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AssetServiceEventQueryVariables,
  APITypes.AssetServiceEventQuery
>;
export const facilityCategories = /* GraphQL */ `query FacilityCategories {
  facilityCategories {
    type
    label
    order
    getSupportURL
    matches
    __typename
  }
}
` as GeneratedQuery<
  APITypes.FacilityCategoriesQueryVariables,
  APITypes.FacilityCategoriesQuery
>;
export const serviceHistoryAvailability = /* GraphQL */ `query ServiceHistoryAvailability($locationNum: String!) {
  serviceHistoryAvailability(locationNum: $locationNum)
}
` as GeneratedQuery<
  APITypes.ServiceHistoryAvailabilityQueryVariables,
  APITypes.ServiceHistoryAvailabilityQuery
>;
export const locationAlerts = /* GraphQL */ `query LocationAlerts($locationNums: [String]!) {
  locationAlerts(locationNums: $locationNums) {
    locationNum
    assetAlerts {
      id
      locationNum
      locationName
      action
      actor
      createdOn
      summary
      deviceType
      detail {
        label
        supportingLabels
        value
        filterSets
        matches
        hiddenMatches
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LocationAlertsQueryVariables,
  APITypes.LocationAlertsQuery
>;
export const flow = /* GraphQL */ `query Flow($flowId: String!, $assetId: String, $locationNum: String) {
  flow(flowId: $flowId, assetId: $assetId, locationNum: $locationNum) {
    id
    name
    shortName
    startStepId
    steps {
      id
      instructions {
        id
        instructionType
        variesBasedOn
        variants {
          key
          changes {
            visible
            optional
            options {
              label
              supportingLabels
              value
              filterSets
              matches
              hiddenMatches
              __typename
            }
            __typename
          }
          __typename
        }

        ... on DisplayTextFlowInstruction {
          header
          content
        }
        ... on SpacingFlowInstruction {
          spacingType
        }
        ... on EquipmentInfoFlowInstruction {
          equipmentInfoLabel
          modelCategoryName
          modelNumber
          manufacturer
          serial
        }
        ... on SelectSearchInputFlowInstruction {
          flowVariableId
          label
          showLabelInline
          placeholderText
          footer
          options {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          otherOption {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          searchHeader
          searchPlaceholderText
          filters {
            label
            subLabel
            keyword
            sortStrategy
            __typename
          }
          sortStrategy
          optional
          visible
          summaryPolicy {
            mappings {
              matchFlowVariableId
              matchFlowVariableValue
              message
              __typename
            }
            __typename
          }
        }
        ... on SummaryInputFlowInstruction {
          flowVariableId
          label
          detailsInput {
            label
            minLines
            maxLines
            placeholder
            footer
            optional
            __typename
          }
        }
        ... on AssetTagGraphicFlowInstruction {
          tagNumber
          state
          assetTagGraphicLabel
        }
        ... on LocationPickerInputFlowInstruction {
          flowVariableId
          locationPickerLabel
          footer
        }
        ... on CloseButtonFlowInstruction {
          text
          style
        }
        ... on ImageFlowInstruction {
          imageURL
        }
        ... on MultiSelectInputFlowInstruction {
          label
          flowVariableId
          options {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          optional
          summaryPolicy {
            template
            mappings {
              matchFlowVariableId
              matchFlowVariableValue
              message
              __typename
            }
            __typename
          }
        }
        ... on RestartButtonFlowInstruction {
          text
          style
        }
        ... on InputFlowInstruction {
          label
          flowVariableId
          optional
          keyboard
          minLines
          maxLines
          footer
          placeholder
          summaryPolicy {
            template
            default
            __typename
          }
        }
        ... on IconFlowInstruction {
          symbol
          color
          footer
        }
        ... on AttachmentInputFlowInstruction {
          label
          placeholder
          footer
          maxAttachments
          optional
        }
        ... on TicketContactPickerInputFlowInstruction {
          flowVariableId
          variesByFlowVariableId
          ticketContactPickerLabel
          footer
        }
        ... on AssetTagInputFlowInstruction {
          flowVariableId
          assetTagInputTitle
          assetTagInputLabel
          placeholder
          summaryPolicy {
            template
            default
            __typename
          }
        }
        ... on SingleSelectInputFlowInstruction {
          label
          flowVariableId
          options {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          summaryPolicy {
            mappings {
              matchFlowVariableId
              matchFlowVariableValue
              message
              __typename
            }
            __typename
          }
        }
        ... on KBArticleFlowInstruction {
          kbNumber
          title
        }
        ... on FormButtonFlowInstruction {
          text
          style
          formId
          formDefaultMappings {
            formVariableId
            flowVariableId
            literalValue
            __typename
          }
          formDefaultSummaryId
        }
      }
      mustBranchDynamically
      staticBranches {
        id
        matchConditions {
          flowVariableId
          matchingValue
          __typename
        }
        nextStepId
        __typename
      }
      branchLabelOverride
      isBacktrackDisabled
      formToSubmit {
        formId
        formVariableMappings {
          formVariableId
          flowVariableId
          literalValue
          __typename
        }
        formSummaryMapping {
          formVariableId
          flowVariableId
          literalValue
          __typename
        }
        successMessage
        restartLabelOverride
        __typename
      }
      heroImageURL
      defaults {
        id
        value
        __typename
      }
      __typename
    }
    summaryMappings {
      matchFlowVariableId
      matchFlowVariableValue
      message
      __typename
    }
    defaults {
      id
      value
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.FlowQueryVariables, APITypes.FlowQuery>;
export const flowInfos = /* GraphQL */ `query FlowInfos($locationNum: String!) {
  flowInfos(locationNum: $locationNum) {
    flowId
    flowName
    title
    description
    thumbnailImageURL
    minimumAppVersion
    __typename
  }
}
` as GeneratedQuery<APITypes.FlowInfosQueryVariables, APITypes.FlowInfosQuery>;
export const nextFlowStep = /* GraphQL */ `query NextFlowStep(
  $flowId: String!
  $currStepId: String
  $inputs: [FlowVariableInput]!
  $locationNum: String
) {
  nextFlowStep(
    flowId: $flowId
    currStepId: $currStepId
    inputs: $inputs
    locationNum: $locationNum
  ) {
    id
    instructions {
      id
      instructionType
      variesBasedOn
      variants {
        key
        changes {
          visible
          optional
          options {
            label
            supportingLabels
            value
            filterSets
            matches
            hiddenMatches
            __typename
          }
          __typename
        }
        __typename
      }

      ... on DisplayTextFlowInstruction {
        header
        content
      }
      ... on SpacingFlowInstruction {
        spacingType
      }
      ... on EquipmentInfoFlowInstruction {
        equipmentInfoLabel
        modelCategoryName
        modelNumber
        manufacturer
        serial
      }
      ... on SelectSearchInputFlowInstruction {
        flowVariableId
        label
        showLabelInline
        placeholderText
        footer
        options {
          label
          supportingLabels
          value
          filterSets
          matches
          hiddenMatches
          __typename
        }
        otherOption {
          label
          supportingLabels
          value
          filterSets
          matches
          hiddenMatches
          __typename
        }
        searchHeader
        searchPlaceholderText
        filters {
          label
          subLabel
          keyword
          sortStrategy
          __typename
        }
        sortStrategy
        optional
        visible
        summaryPolicy {
          mappings {
            matchFlowVariableId
            matchFlowVariableValue
            message
            __typename
          }
          __typename
        }
      }
      ... on SummaryInputFlowInstruction {
        flowVariableId
        label
        detailsInput {
          label
          minLines
          maxLines
          placeholder
          footer
          optional
          __typename
        }
      }
      ... on AssetTagGraphicFlowInstruction {
        tagNumber
        state
        assetTagGraphicLabel
      }
      ... on LocationPickerInputFlowInstruction {
        flowVariableId
        locationPickerLabel
        footer
      }
      ... on CloseButtonFlowInstruction {
        text
        style
      }
      ... on ImageFlowInstruction {
        imageURL
      }
      ... on MultiSelectInputFlowInstruction {
        label
        flowVariableId
        options {
          label
          supportingLabels
          value
          filterSets
          matches
          hiddenMatches
          __typename
        }
        optional
        summaryPolicy {
          template
          mappings {
            matchFlowVariableId
            matchFlowVariableValue
            message
            __typename
          }
          __typename
        }
      }
      ... on RestartButtonFlowInstruction {
        text
        style
      }
      ... on InputFlowInstruction {
        label
        flowVariableId
        optional
        keyboard
        minLines
        maxLines
        footer
        placeholder
        summaryPolicy {
          template
          default
          __typename
        }
      }
      ... on IconFlowInstruction {
        symbol
        color
        footer
      }
      ... on AttachmentInputFlowInstruction {
        label
        placeholder
        footer
        maxAttachments
        optional
      }
      ... on TicketContactPickerInputFlowInstruction {
        flowVariableId
        variesByFlowVariableId
        ticketContactPickerLabel
        footer
      }
      ... on AssetTagInputFlowInstruction {
        flowVariableId
        assetTagInputTitle
        assetTagInputLabel
        placeholder
        summaryPolicy {
          template
          default
          __typename
        }
      }
      ... on SingleSelectInputFlowInstruction {
        label
        flowVariableId
        options {
          label
          supportingLabels
          value
          filterSets
          matches
          hiddenMatches
          __typename
        }
        summaryPolicy {
          mappings {
            matchFlowVariableId
            matchFlowVariableValue
            message
            __typename
          }
          __typename
        }
      }
      ... on KBArticleFlowInstruction {
        kbNumber
        title
      }
      ... on FormButtonFlowInstruction {
        text
        style
        formId
        formDefaultMappings {
          formVariableId
          flowVariableId
          literalValue
          __typename
        }
        formDefaultSummaryId
      }
    }
    mustBranchDynamically
    staticBranches {
      id
      matchConditions {
        flowVariableId
        matchingValue
        __typename
      }
      nextStepId
      __typename
    }
    branchLabelOverride
    isBacktrackDisabled
    formToSubmit {
      formId
      formVariableMappings {
        formVariableId
        flowVariableId
        literalValue
        __typename
      }
      formSummaryMapping {
        formVariableId
        flowVariableId
        literalValue
        __typename
      }
      successMessage
      restartLabelOverride
      __typename
    }
    heroImageURL
    defaults {
      id
      value
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NextFlowStepQueryVariables,
  APITypes.NextFlowStepQuery
>;
export const featureToggleEnabled = /* GraphQL */ `query FeatureToggleEnabled($flagKey: String!) {
  featureToggleEnabled(flagKey: $flagKey)
}
` as GeneratedQuery<
  APITypes.FeatureToggleEnabledQueryVariables,
  APITypes.FeatureToggleEnabledQuery
>;
export const health = /* GraphQL */ `query Health {
  health {
    id
    status
    __typename
  }
}
` as GeneratedQuery<APITypes.HealthQueryVariables, APITypes.HealthQuery>;
